import { render, staticRenderFns } from "./SnackBarV2.vue?vue&type=template&id=32b1ef41&scoped=true"
import script from "./SnackBarV2.vue?vue&type=script&lang=js"
export * from "./SnackBarV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_lodash@4.17.21_prettier@2.8.8_vue-template-compiler@2.7.14_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1ef41",
  null
  
)

export default component.exports